import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
export default function Home() {
  const history = useHistory()
  const { menus } = useSelector((state) => state.login)

  useEffect(() => {
    const findItem = menus?.find((i) => i.menu_code === 'SYS_MANAGE')
    if (findItem) {
      const url = findItem?.children?.[0]?.menu_url
      if (url !== '/home') {
        history.push(findItem?.children?.[0]?.menu_url)
      }
    }
  }, [menus])

  return <div>首页</div>
}
